import React from 'react';

const Header = () => {
    return (
        <div className='py-5'
            // style={{
            //     backgroundSize: "cover",
            //     backgroundPosition: "center",
            //     backgroundRepeat: "no-repeat",
            //     background: "url(https://images.pexels.com/photos/633409/pexels-photo-633409.jpeg?auto=compress&cs=tinysrgb&w=600"
            // }}
        >
            <div className='container mx-auto text-center mb-5'>
                <h3 className='md:text-2xl text-xl font-poppins font-extrabold uppercase py-2 text-gray-400'>Contact</h3>
                <h2 className='md:text-4xl text-2xl font-poppins font-bold text-primary'>CONTACT WITH ME</h2>
            </div>
        </div>
    );
};

export default Header;